export const environment = {
  production: true,
  apiUrl: 'https://pronutriconsult.hp.wavenet-test.be',
  deployUrlPrefix: '/'
};
